import React from 'react';
import { FormattedDate } from 'react-intl';
var CalendarDate = function (_a) {
    var date = _a.date, fallback = _a.fallback;
    if (date == null)
        return (React.createElement(React.Fragment, null, "fallback"));
    return (React.createElement(FormattedDate, { value: date, year: "numeric", month: "long", day: "2-digit", minute: "numeric", hour: "numeric", hour12: true }));
};
export default CalendarDate;
